const commonConfig = {
  // baseUrl: "https://saltcloud.chenkeyan.com"
  baseUrl: process.env.REACT_APP_BASE_URL
}
export default commonConfig;
